import { IconSun, IconMoonStars } from "@tabler/icons-react";
import {
  useMantineColorScheme,
  useComputedColorScheme,
  SegmentedControl,
  Center,
  rem,
  useMantineTheme,
  Group,
} from "@mantine/core";

const ThemeToggle2 = () => {
  const theme = useMantineTheme();
  const { setColorScheme } = useMantineColorScheme();
  const computedColorScheme = useComputedColorScheme("light", {
    getInitialValueInEffect: true,
  });

  return (
    <SegmentedControl
      radius="sm"
      value={computedColorScheme}
      onChange={(value) => setColorScheme(value as "light" | "dark")}
      data={[
        {
          value: "light",
          label: (
            <Group gap={6} justify="center">
              <IconSun
                style={{ width: rem(16), height: rem(16) }}
                color={theme.colors.yellow[6]}
                stroke={2.5}
              />
              Light
            </Group>
          ),
        },
        {
          value: "dark",
          label: (
            <Group gap={6} justify="center">
              <IconMoonStars
                style={{ width: rem(16), height: rem(16) }}
                color={theme.colors.blue[6]}
                stroke={2.5}
              />
              Dark
            </Group>
          ),
        },
      ]}
      size="xs"
      fullWidth
    />
  );
};

export default ThemeToggle2;
